export default __webpack_public_path__ + "static/media/019-bicycle-1.8dfa3c05.png";